import SignupForm from "../../components/form/SignupForm";
import { Link, useNavigate } from "react-router-dom";
import styles from "./signup.module.css";
import { useState } from "react";
import Loader from "../../../admin/components/Loader";
import { Home } from "react-feather";
import axios from "axios";
import { StorageSetItem } from "../../../admin/components/StorageComp";
import { PayPalButtons } from "@paypal/react-paypal-js";

const Signup = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState(null);
  const [formUserData, setFormUserData] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);

  async function onSubmit(data, userData) {
    setFormData(data);
    setFormUserData(userData);
    setStep(2);
  }

  const handlePlanSelect = () => {
    setLoading(true);
    axios.post(process.env.REACT_APP_API_URL + "v1/subscribe-free-trial", { company_id: formData?.id, user_id: formUserData?.id }).then((response) => {
      setLoading(false);
      if (response.data.status === "SUCCESS") {
        const resData = response.data.data;
        StorageSetItem("bookAuthData", JSON.stringify(resData), 24 * 60 * 60 * 1000);

        setTimeout(() => {
          navigate("/dashboard");
        }, 100);
      }
    }).catch((error) => {
      setLoading(false);
    });
  }

  const handleCustomPlanSelect = () => {
    setLoading(true);
    axios.post(process.env.REACT_APP_API_URL + "v1/subscribe-custom", { company_id: formData?.id, user_id: formUserData?.id }).then((response) => {
      setLoading(false);
      if (response.data.status === "SUCCESS") {
        const resData = response.data.data;
        StorageSetItem("bookAuthData", JSON.stringify(resData), 24 * 60 * 60 * 1000);

        setTimeout(() => {
          navigate("/dashboard");
        }, 100);
      }
    }).catch((error) => {
      setLoading(false);
    });
  }

  const createOrder = (data, actions) => {
    return actions.order.create({
      purchase_units: [
        {
          description: "Purchage Subscribe Plan",
          amount: {
            currency_code: "GBP",
            value: selectedPlan?.monthly_amount,
          },
        },
      ],
      application_context: {
        shipping_preference: "NO_SHIPPING",
      },
    }).then((orderID) => {
      return orderID;
    });
  };

  const onApprove = (data, actions) => {
    setLoading(true);
    return actions.order.capture().then(function (details) {
      let postData = { company_id: formData?.id, user_id: formUserData?.id };
      postData = { ...postData, subscription_id: selectedPlan?.id, total_booking: 0, payment_amount: details?.purchase_units[0]?.payments?.captures[0]?.amount?.value, transaction_id: details?.purchase_units[0]?.payments?.captures[0]?.id, payer_id: details?.payer?.payer_id, payer_name: details?.payer?.name?.given_name + ' ' + details?.payer?.name?.surname, payer_email: details?.payer?.email_address };

      axios.post(process.env.REACT_APP_API_URL + "v1/signup-subscription", postData).then((response) => {
        const resData = response.data.data;
        StorageSetItem("bookAuthData", JSON.stringify(resData), 24 * 60 * 60 * 1000);

        setTimeout(() => {
          navigate("/dashboard");
        }, 100);
      }).catch((error) => {
        setLoading(false);
      });
    });
  }

  return (<>
    <Loader open={loading} setOpen={setLoading.bind(this)} />
    <div className={`${styles.MainDiv}`}>
      <div className={`${styles.LoginFormSec}`}>

        <div className={`${styles.LohinForm}`}>
          <Link to={"/"} className={`${styles.BackHomeBU}`}><Home />Back to home</Link>
          <h2 className={`${styles.BookingFormTitle} ${styles.Heading}`}>Sign Up</h2>
          {step === 1 && <p className={`${styles.LoginformSmTitle}`}>Create an account</p>}
          {step === 2 && <p className={`${styles.LoginformSmTitle}`}>Choose Your Subscription Plan</p>}
          {step === 3 && <p className={`${styles.LoginformSmTitle}`}>Pay your amount</p>}
          {step === 1 && <SignupForm onSubmit={onSubmit.bind(this)} setLoading={setLoading.bind(this)} />}
          {step === 2 && <div className={`${styles.PlanWrapper}`}>

            <div className={styles.PlanGrid}>

              {/* FREE TRIAL PLAN */}
              <div className={`${styles.PlanCard} ${styles.FreeTrialCard}`}>
                <div className={styles.TrialBadge}>FREE</div>
                <h3>7 Day Free Trial</h3>
                <h1>£0</h1>

                <ul>
                  <li>✓ Bookings</li>
                  <li>✓ Customers</li>
                  <li>✓ Items</li>
                  <li>✓ Customer Portal</li>
                </ul>

                <button type="button" className={styles.FreeTrialBtn} onClick={() => handlePlanSelect()}>Start Free Trial</button>
              </div>

              {/* STANDARD */}
              <div className={styles.PlanCard}>
                <h3>Standard</h3>
                <h1>£350 <span>/Month</span></h1>

                <ul>
                  <li>✓ Bookings</li>
                  <li>✓ Customers</li>
                  <li>✓ Items</li>
                  <li>✓ Customer Portal</li>
                </ul>

                <button type="button" className={styles.SelectPlanBtn} onClick={() => { setSelectedPlan({ id: 2, name: 'Standard', monthly_amount: 350 }); setStep(3); }}>Subscribe</button>
              </div>
            </div>

            <div className={styles.PlanGrid}>


              {/* PREMIUM */}
              <div className={`${styles.PlanCard} ${styles.Recommended}`}>
                <div className={styles.Badge}>Most Popular</div>
                <h3>Premium</h3>
                <h1>£513 <span>/Month</span></h1>

                <ul>
                  <li>✓ Everything in Standard</li>
                  <li>✓ Driver Management</li>
                  <li>✓ Shipping & Delivery</li>
                  <li>✓ Apps Included</li>
                </ul>

                <button type="button" className={styles.SelectPlanBtn} onClick={() => { setSelectedPlan({ id: 3, name: 'Premium', monthly_amount: 513 }); setStep(3); }}>Subscribe</button>
              </div>

              {/* ENTERPRISE */}
              <div className={styles.PlanCard}>
                <h3>Full</h3>
                <h1>£2518 <span>/Month</span></h1>

                <ul>
                  <li>✓ Everything in Premium</li>
                  <li>✓ Referral System</li>
                  <li>✓ Membership Benefits</li>
                  <li>✓ 24/7 Support</li>
                </ul>

                <button type="button" className={styles.SelectPlanBtn} onClick={() => { setSelectedPlan({ id: 4, name: 'Full', monthly_amount: 2518 }); setStep(3); }}>Subscribe</button>
              </div>

            </div>
            <div className={styles.PlanGrid} style={{ justifyContent: 'center' }}>

              {/* CUSTOM PLAN */}
              <div className={`${styles.PlanCard} ${styles.CustomCard}`}>
                <div className={styles.EnterpriseBadge}>Custom</div>

                <h3>Custom Plan</h3>
                <h1>Custom Pricing</h1>

                <p className={styles.CustomText}>
                  Tailored logistics solution for large scale operations
                </p>

                <button
                  type="button"
                  className={styles.ContactBtn}
                  onClick={() => handleCustomPlanSelect()}
                >
                  Contact Sales
                </button>
              </div>

            </div>
          </div>}

          {step === 3 && <div className={`${styles.SubscribePaySec}`}>
            <p className={`${styles.PlanPayTitle}`}>Plan: {selectedPlan?.name}</p>
            <p className={`${styles.PlanPayAmount}`}>Payable Amount: &pound;{selectedPlan?.monthly_amount}</p>

            <PayPalButtons style={{ layout: "vertical" }} createOrder={createOrder} onApprove={onApprove} />
          </div>}

        </div>
      </div>

      <div className={`${styles.LoginBGSec}`}>
        <img src="/images/loginBG1.jpg" alt="" />
      </div>
    </div>
  </>);
}

export default Signup;